import {
    getData,
} from './Services'

export const getCombos = async (user_id) => {
    //const res = await getData('/combos');
    const res = await getData(`/combos?page=1&perPage=20&user_id=${user_id}`);
    return res
}

export const getCombosPaginate = async ({
  searchTerm,
  selectedRamo,
  selectedRubro,
  selectedSubrubro,
  selectedMarca,
  page,
  perPage,
  user_id,
  orderBy,
  orden,
}) => { 
  console.log('pega',page,'per',perPage)
  const params = new URLSearchParams();
  if (searchTerm) params.append("search", searchTerm);
  if (selectedRamo) params.append("ramo_Id", selectedRamo);
  if (selectedRubro) params.append("rubro_Id", selectedRubro);
  if (selectedSubrubro) params.append("subrubro_Id", selectedSubrubro);
  if (selectedMarca) params.append("marca_Id", selectedMarca);
  if (page) params.append("page", page);
  if (perPage) params.append("perPage", perPage);
  if (user_id) params.append("user_id", user_id);
  if (orderBy) params.append("orderBy", orderBy);
  if (orden) params.append("orden", orden);

  const res = await getData(`/combos?${params.toString()}`);
  console.log("ressssssssss",res)
  return res;
};